table{width:100%}
/*# sourceMappingURL=auth-log.component-AN6T43JY.css.map */
